import React, { createContext } from 'react';

// material icons (outlined, minimal)
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import SellOutlinedIcon from '@mui/icons-material/SellOutlined';
import DiamondOutlinedIcon from '@mui/icons-material/DiamondOutlined';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import CakeOutlinedIcon from '@mui/icons-material/CakeOutlined';
import TranslateIcon from '@mui/icons-material/Translate';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import ExploreOutlinedIcon from '@mui/icons-material/ExploreOutlined';
import VerifiedOutlinedIcon from '@mui/icons-material/VerifiedOutlined';
import InterestsOutlinedIcon from '@mui/icons-material/InterestsOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import TuneIcon from '@mui/icons-material/Tune';

// When true, the shared AdvancedFilters sub-components render the v2 styling
// (per-row icons + placeholders). v1 never provides this, so it stays false.
export const AdvFilterV2Context = createContext(false);

// [matcher, Icon, colour] — cool, theme-aligned palette (blues/indigos/teals
// with a few accents), no yellow. Order matters: more specific first, and
// `language` must precede `age` because "lAGEuage"… "language" contains "age".
const RULES = [
  [/language/i, TranslateIcon, '#0891b2'],
  [/email/i, EmailOutlinedIcon, '#0e7490'],
  [/phone|mobile/i, PhoneOutlinedIcon, '#16a34a'],
  [/campaign budget|max price|budget/i, PaymentsOutlinedIcon, '#2563eb'],
  [/mega|macro|micro|nano/i, DiamondOutlinedIcon, '#7c3aed'],
  [/price|cost|rupee/i, SellOutlinedIcon, '#2563eb'],
  [/engagement rate|engagement/i, TrendingUpIcon, '#0d9488'],
  [/engaged user|reach/i, PeopleAltOutlinedIcon, '#3b56d6'],
  [/view/i, VisibilityOutlinedIcon, '#4f46e5'],
  [/age/i, CakeOutlinedIcon, '#db2777'],
  [/deliverable/i, AssignmentOutlinedIcon, '#0e7490'],
  [/country/i, PublicOutlinedIcon, '#16a34a'],
  [/state/i, MapOutlinedIcon, '#0d9488'],
  [/region/i, ExploreOutlinedIcon, '#2563eb'],
  [/credibility|verified/i, VerifiedOutlinedIcon, '#16a34a'],
  [/interest/i, InterestsOutlinedIcon, '#7c3aed'],
  [/location|city/i, LocationOnOutlinedIcon, '#2563eb'],
  [/creator|audience|gender|follower|subscriber/i, GroupsOutlinedIcon, '#3b56d6'],
];

const matchFor = (title = '') => {
  for (const [re, Icon, color] of RULES) if (re.test(title)) return [Icon, color];
  return [TuneIcon, '#1b2550'];
};

// Small leading icon for a filter row title.
export const FilterIcon = ({ title, sx }) => {
  const [Icon, color] = matchFor(title);
  return <Icon sx={{ fontSize: 16, color, mr: 0.75, flexShrink: 0, ...sx }} />;
};

export default AdvFilterV2Context;
